export interface IProduct {
  code: string;
  title: string;
  description: string;
  //price: number;
  quantity: number;
  taxable: boolean;
  serviceCodeId: number;
  status: string;
  selected: boolean;
  isPin: boolean;
  image: string;
  initials: string;
  activePrice: number;
  source: string;
}

export class Product implements IProduct {
  code = null;
  title = null;
  description = null;
  //price = null;
  quantity = null;
  taxable = false;
  serviceCodeId = null;
  status =  null;
  selected=false;
  isPin=false;
  image: string;
  initials: null;
  activePrice=null;
  source=null;
}
